import { render } from "./admin-statistics.vue?vue&type=template&id=536ec1c8"
import script from "./admin-statistics.vue?vue&type=script&lang=js"
export * from "./admin-statistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__